import { render, staticRenderFns } from "./waitExamine.vue?vue&type=template&id=0b923a48"
import script from "./waitExamine.vue?vue&type=script&lang=js"
export * from "./waitExamine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports